.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  background-color: var(--white);
  padding: 3rem 1.5rem 5rem 1.5rem;
  border-radius: 0 0 8px 8px;
}

p {
  margin-left: 36px;
  padding-bottom: 18px;
}

.link {
  font-family: Aeroport;
  font-size: 0.9rem;
  color: var(--text-dark);
}

.link:hover {
  color: var(--text-dark) !important;
}
